import { ChainId } from '../../sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.POA]: '0x27afAAd8E53a5AA8204a91fc918968621b7522d3'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
